import ReportsStage from '../HomePageSections/Reports.jsx';

const Home = () => {
  return (
    <div className="w-[100%] h-[100%] overflow-scroll">
      <div className="w-[100%] relative text-[#212121] overflow-auto ">
        <ReportsStage />
      </div>
    </div>
  );
};

export default Home;
